function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#18a1db",
  d: "M28.49 14.065L15.21.785A2.67 2.67 0 0 0 13.317 0a2.67 2.67 0 0 0-1.894.785l-7.272 7.27a2.719 2.719 0 0 0 0 3.822l1.206 1.238h2.78l-2.595-2.628a.745.745 0 0 1 0-1.034l.96-.93 4.563 4.592h4.377L8.69 6.33l4.123-4.14a.725.725 0 0 1 .504-.215c.11 0 .323.023.504.204l13.28 13.277c.182.183.21.393.21.504a.75.75 0 0 1-.23.504l-.753.735v2.78l2.144-2.124c1.046-1.049 1.065-2.744.018-3.79z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#18a1db",
  d: "M24.905 17.031v7.104H.735V17.03c0-1.479 1.264-2.67 2.744-2.67h18.78c1.48 0 2.646 1.191 2.646 2.67zM9.247 19.766a1.95 1.95 0 0 0-3.299-1.404 1.95 1.95 0 1 0 0 2.81 1.949 1.949 0 0 0 3.299-1.405z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#18a1db",
  d: "M.734 27.313C.734 28.793 2 30 3.48 30h18.78c1.48 0 2.647-1.207 2.647-2.687v-.157H.734z"
}))))));

var SvgIconCreditCard = function SvgIconCreditCard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconCreditCard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-credit-card.69b31ea3.svg";
export { ForwardRef as ReactComponent };